import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=3d10ce6b&scoped=true"
import script from "./AccountDetail.vue?vue&type=script&lang=js"
export * from "./AccountDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=3d10ce6b&prod&lang=scss&scoped=true"
import style1 from "./AccountDetail.vue?vue&type=style&index=1&id=3d10ce6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10ce6b",
  null
  
)

export default component.exports